import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { useCurrentUserDetails } from '../../entities/user/model';
import { useCallback } from 'react';

export const useInvoiceNotifications = (invoiceId: string, type: 'email') => {
  const { getCurrentOrganizationId } = useCurrentUserDetails();
  const { getAccessTokenSilently } = useAuth0();
  const query = useQuery({
    queryKey: ['invoice-notifications', invoiceId, type],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/api/public/invoices/notification/list`,
        {
          params: {
            invoiceId,
            organizationId: getCurrentOrganizationId(),
            channelType: type,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data?.result || [];
    },
    enabled: !!invoiceId,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
  });

  return {
    invoiceNotifications: query.data,
    isPending: query.isPending,
    isFetching: query.isFetching,
  };
};

export const useInvalidateNotifications = () => {
  const qc = useQueryClient();

  const invalidateNotifications = useCallback(
    (invoiceId: string) => {
      return qc.invalidateQueries({
        queryKey: ['invoice-notifications', invoiceId],
      });
    },
    [qc]
  );

  return {
    invalidateNotifications,
  };
};
